var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgResponsive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "28.369px",
    height: "28.369px",
    viewBox: "0 0 28.369 28.369",
    enableBackground: "new 0 0 28.369 28.369",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_197",
    transform: "translate(-1426.928 -214.172)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_26",
    fill: "none",
    stroke: "#01C28D",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    x1: 1450.978,
    y1: 233.993,
    x2: 1450.978,
    y2: 214.262
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_27",
    fill: "none",
    stroke: "#01C28D",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    x1: 1441.112,
    y1: 224.128,
    x2: 1441.112,
    y2: 214.262
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_28",
    fill: "none",
    stroke: "#01C28D",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    x1: 1431.247,
    y1: 242.448,
    x2: 1431.247,
    y2: 222.718
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_575",
    x: 1448.159,
    y: 235.401,
    fill: "none",
    stroke: "#01C28D",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    width: 5.638,
    height: 5.639
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_576",
    x: 1438.293,
    y: 225.537,
    fill: "none",
    stroke: "#01C28D",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    width: 5.638,
    height: 5.638
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_577",
    x: 1428.427,
    y: 215.671,
    fill: "none",
    stroke: "#01C28D",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    width: 5.638,
    height: 5.638
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_29",
    fill: "none",
    stroke: "#01C28D",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    x1: 1441.112,
    y1: 242.45,
    x2: 1441.112,
    y2: 232.584
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResponsive);
export default __webpack_public_path__ + "static/media/responsive.e51c34df899597fb76fa53667821d0df.svg";
export { ForwardRef as ReactComponent };